import React, { useState } from "react";
import { Link } from 'react-router-dom';

const Eventprofile = () => {
    const [isSearchbar, toggleSearchBar] = useState(false);
    const [showAddModal, setShowAddModal] = useState(false);

    return (
        <>
            <div className={`overlay ${isSearchbar ? 'active' : ''}`} onClick={() => toggleSearchBar(false)}></div>
            <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>
            <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>     <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>     <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>     <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>     <div className="container-fluid p-4 min-vh-100 mt-10">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h2>Events</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to="/events/admin/">Amasi</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Event Attendees</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-2 col-sm-12 text-right hidden-xs"></div>
                        <div className="col-md-4 col-sm-12 text-right">
                            <div className="  mb-3">
                                <div className=' '>
                                    {/* <input type="text" className="form-control" placeholder="Search here..." /> */}
                                    <span onClick={() => setShowAddModal(true)}

                                        className="btn btn-outline-primary mr-1" title=""> Add Attendees</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>



             
            </div>
           
        </>
    );
};

export default Eventprofile;